import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<PurchaseOrderOrderSummary>({})
export default class PurchaseOrderOrderSummary extends Vue {

  // #region @Props

  @Prop({ default: '' })
  protected purchaseOrderId!: string;

  // #endregion

  // #region @Refs
  // #endregion

  // #region Props
  // #endregion

  // #region Plugin props
  // #endregion

  // #region Lifecycle hooks / Init
  // #endregion

  // #region Handlers
  // #endregion

  // #region Helpers
  // #endregion

  // #region API Requests
  // #endregion

  // #region Getters & Setters
  // #endregion

  // #region @Watchers
  // #endregion
}
